import {domReady} from "./xpage/index"

domReady(() => {
	
})